__turbopack_context__.v({
  "className": "poppins_8ad66036-module__NYdJnq__className",
});
